//configuring keyboard shortcuts for video player
export const configKeyShortcuts = (videoPlayerInfo, videoNode) => {
    window && window.addEventListener("keydown", (event) => {
        const modalOpening = document.getElementsByClassName('modal');
        const popupOpening = document.getElementsByClassName("popup-view")
        const overlayOpening = popupOpening.length > 0 && popupOpening[0].childNodes[0].className.includes("overlay-player")
        const videoModuleWrapperOpening = document.getElementsByClassName('video-module-wrapper');
        const standalonePlayer02Opening = document.getElementsByClassName('StandaloneVideoPlayer02-player');
        const standalonePlayer01Opening = document.getElementsByClassName('StandaloneVideoPlayer01__player');
        const videoPlayer05Opening = document.getElementsByClassName('video-player-with-info-05');
        let configKeyEnabled = false
        if (overlayOpening) {
            configKeyEnabled = true
        } else if (popupOpening.length === 0 && (modalOpening.length > 0 || videoModuleWrapperOpening.length > 0 || standalonePlayer02Opening.length > 0 || standalonePlayer01Opening.length > 0 || videoPlayer05Opening.length > 0)) {
            configKeyEnabled = true
        } else {
            configKeyEnabled = false
        }
        if (configKeyEnabled) {
            const searchOpened = document.getElementsByClassName('search-container-input')[0];
            const searchOpenedMobile = document.getElementsByClassName('news-search-input')[0];
            const searchOpenedDesktop = document.getElementsByClassName('news-search-input')[1];
            const deviceCode = document.getElementsByClassName('device-code')[0];
            if ((document.activeElement === searchOpened) || (document.activeElement === searchOpenedDesktop) || (document.activeElement === searchOpenedMobile) || document.activeElement === deviceCode) return;
            const playButton = videoPlayerInfo && videoPlayerInfo.controlBar && videoPlayerInfo.controlBar.playToggle && videoPlayerInfo.controlBar.playToggle.el_
            const muteButton = videoPlayerInfo && videoPlayerInfo.controlBar && videoPlayerInfo.controlBar.volumePanel && videoPlayerInfo.controlBar.volumePanel.muteToggle && videoPlayerInfo.controlBar.volumePanel.muteToggle.el_
            const fullscreenButton = videoPlayerInfo && videoPlayerInfo.controlBar && videoPlayerInfo.controlBar.fullscreenToggle && videoPlayerInfo.controlBar.fullscreenToggle.el_
            const rewindButton = videoPlayerInfo && videoPlayerInfo.controlBar && videoPlayerInfo.controlBar.childNameIndex_ && videoPlayerInfo.controlBar.childNameIndex_.VjsRewindBtn && videoPlayerInfo.controlBar.childNameIndex_.VjsRewindBtn.el_.childNodes[0]
            const newsRewinfButton = videoPlayerInfo && videoPlayerInfo.controlBar && videoPlayerInfo.controlBar.childNameIndex_ && videoPlayerInfo.controlBar.childNameIndex_.NewsVjsRewindBtn && videoPlayerInfo.controlBar.childNameIndex_.NewsVjsRewindBtn.el_.childNodes[0]
            const forwardButton = videoPlayerInfo && videoPlayerInfo.controlBar && videoPlayerInfo.controlBar.childNameIndex_ && videoPlayerInfo.controlBar.childNameIndex_.VjsSkipBtn && videoPlayerInfo.controlBar.childNameIndex_.VjsSkipBtn.el_.childNodes[0]
            switch (event.key) {
                case " ": //space button key
                    event.preventDefault()
                    videoNode && videoNode.focus()
                    playButton && playButton.click();
                    return;
                case "m": //M button key
                    event.preventDefault()
                    videoNode && videoNode.focus()
                    muteButton && muteButton.click();
                    return;
                case "M": //M button key
                    event.preventDefault()
                    videoNode && videoNode.focus()
                    muteButton && muteButton.click();
                    return;
                case "f": //F button key
                    event.preventDefault()
                    videoNode && videoNode.focus()
                    fullscreenButton && fullscreenButton.click();
                    return;
                case "F": //F button key
                    event.preventDefault()
                    videoNode && videoNode.focus()
                    fullscreenButton && fullscreenButton.click();
                    return;
                case "ArrowLeft": //ArrowLeft button key
                    event.preventDefault()
                    videoNode && videoNode.focus()
                    rewindButton && rewindButton.click()
                    newsRewinfButton && newsRewinfButton.click()
                    return;
                case "ArrowRight": //ArrowRight button key
                    event.preventDefault()
                    videoNode && videoNode.focus()
                    forwardButton && forwardButton.click();
                    return;
                default: return;
            }
        } else return
    })
}